import { ChangeEvent } from "react";

import { TFunction } from "react-i18next";

import { File as IFile } from "../models/file";
import { convertToBase64 } from "./convertToBase64";
import { fileIsValid } from "./fileIsValid";

export const convertEventToFile = async (
  event: ChangeEvent<HTMLInputElement>,
  translate: TFunction<"translation", undefined>,
  allowedExtensions?: string[]
) => {
  if (event?.target && event?.target?.files && event?.target?.files?.length > 0) {
    const file = event?.target?.files[0];

    const splittedFileName = file?.name?.split(".");

    if (splittedFileName && splittedFileName?.length > 0) {
      const extensionFromName = splittedFileName[splittedFileName.length - 1];

      const lastIndexOf = file?.name?.lastIndexOf(".");
      const name = file?.name?.slice(0, lastIndexOf);

      const fileToSave = {
        name,
        type: file.type,
        extension: extensionFromName,
        size: file.size,
      } as IFile;

      if (file && fileIsValid(translate, fileToSave, { allowedExtensions })) {
        const base64 = await convertToBase64(file);

        if (base64)
          return {
            ...fileToSave,
            uri: base64?.toString(),
          } as IFile;
      }
    }
  }

  return null;
};

export const convertFilesToBatch = async (
  files: FileList,
  translate: TFunction<"translation", undefined>,
  allowedExtensions?: string[]
): Promise<{
  successfulFiles: IFile[];
  failedFiles: Array<{ fileName: string; error: string }>;
}> => {
  const results = {
    successfulFiles: [] as IFile[],
    failedFiles: [] as Array<{ fileName: string; error: string }>,
  };

  for (let i = 0; i < files.length; i++) {
    try {
      const fileEvent = {
        target: {
          files: [files[i]],
        },
      } as unknown as ChangeEvent<HTMLInputElement>;

      const convertedFile = await convertEventToFile(fileEvent, translate, allowedExtensions);

      if (convertedFile) {
        results.successfulFiles.push(convertedFile);
      } else {
        results.failedFiles.push({
          fileName: files[i].name,
          error: translate("invalidFileType"),
        });
      }
    } catch (error) {
      results.failedFiles.push({
        fileName: files[i].name,
        error: error instanceof Error ? error.message : translate("uploadFailed"),
      });
    }
  }

  return results;
};
